import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export interface QuickRepliesListProps {
  replies: string[];
  onSelect: (reply: string) => void;
}

export const QuickRepliesList: FC<QuickRepliesListProps> = ({
  replies,
  onSelect,
}) => (
  <div className="-mx-4 -mb-3 mt-3">
    {replies.map((reply, index) => (
      <QuickReplyButton key={+index} onClick={() => onSelect(reply)}>
        {reply}
      </QuickReplyButton>
    ))}
  </div>
);

interface QuickReplyButtonProps {
  children: ReactNode;
  className?: string;
  onClick: () => void;
}

export const QuickReplyButton: FC<QuickReplyButtonProps> = ({
  children,
  className,
  onClick,
}) => (
  <button
    type="button"
    className={cx(
      "group flex h-[42px] w-full cursor-pointer appearance-none items-center justify-center bg-transparent px-3",
      "border-t-2 border-l-0 border-b-0 border-r-0 border-solid border-white hover:bg-[#F2F2F2] active:border-solid active:border-white active:bg-[#EBEBEB]",
      className
    )}
    onClick={onClick}
  >
    <span className="font-secondary text-primary-800 text-sm font-medium group-hover:underline">
      {children}
    </span>
  </button>
);
